import React from "react";
import type { BuilderStepProps } from "campaign-builder/config";
import { CampaignDetailsCard } from "./CampaignDetailsCard";
import { AudienceCard } from "./AudienceCard";
import { DeliveryRulesCard } from "./DeliveryRulesCard";

export const AdmTargetingStep: React.FC<BuilderStepProps> = () => (
  <div className="flex flex-col gap-4" data-copilot-step="ADM Targeting">
    <CampaignDetailsCard />
    <AudienceCard />
    <DeliveryRulesCard />
  </div>
);
